var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"asset-type d-flex align-center"},[_c(_setup.SIcon,{staticClass:"asset-type-icon mr-1",attrs:{"icon":_setup.icon}}),_c(_setup.SEllipsisTooltip,{attrs:{"content":_setup.name}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }